import { render, staticRenderFns } from "./M3_F7.vue?vue&type=template&id=bcb028be&scoped=true"
import script from "./M3_F7.vue?vue&type=script&lang=js"
export * from "./M3_F7.vue?vue&type=script&lang=js"
import style0 from "./M3_F7.vue?vue&type=style&index=0&id=bcb028be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb028be",
  null
  
)

export default component.exports